import { Coin } from '@cakedefi/cake-sdk';

export function getCoinCategoryName(coin: Coin) {
  if (!coin.category) {
    return 'Decentralized Asset';
  }

  const categoryName = coin.category.toLowerCase();
  return categoryName.charAt(0).toUpperCase() + categoryName.slice(1);
}
